export default "__VITE_ASSET__WJHUhcNZ__"